<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Master Kelompok Pelangan 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(iklan)="data">
          <span v-if="(data.item.advertiser==1)">Direct Adverter</span>
          <span v-else> <span v-if="(data.item.iklan==1)">Agency</span></span>
        </template>
        <template v-slot:cell(koran)="data">
          <span v-if="(data.item.koranagen==1)">Reseller/Agen</span>
          <span v-else><span v-if="(data.item.koran==1)">Subscriber</span></span>
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="6">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="6">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card >
            <div slot="header">Kelompok Pelanggan - Add/Edit Form 
            </div>
              <b-form-group  label-cols=3  label="Group Code" >
                  <b-form-input v-model="frmdata.group_code" :state="!$v.frmdata.group_code.$error"></b-form-input>
              </b-form-group>
              <b-form-group  label-cols=3  label="Group Name" >
                  <b-form-input v-model="frmdata.group_name" :state="!$v.frmdata.group_name.$error"></b-form-input>
              </b-form-group>
              <b-form-group  label-cols=3  label="Advertising" v-if="(user.iklan==1)">
                  <b-form-checkbox  class="mt-2" v-model="frmdata.agency" value=1 unchecked-value=0>
                        Advertising Agency
                  </b-form-checkbox>
                  <b-form-checkbox  class="mt-2" v-model="frmdata.advertiser" value=1 unchecked-value=0>
                        Direct Advertiser                 
                  </b-form-checkbox>
              </b-form-group>
              <b-form-group  label-cols=3  label="Newspaper" v-if="(user.koran==1)">
                  <b-form-checkbox  class="mt-2" v-model="frmdata.koranagen" value=1 unchecked-value=0>
                        Newspaper Reseller (Agen Koran)
                  </b-form-checkbox>
                  <b-form-checkbox  class="mt-2" v-model="frmdata.koran" value=1 unchecked-value=0>
                        Newspaper Customer / Subscriber
                  </b-form-checkbox>
              </b-form-group>

            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
             <b-button variant="secondary" class="mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>
          </b-card>
        </b-col>
    </b-row>
  </div>
</template>


<script>
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        group_code: { required },
        group_name: { required },
    },
  }, 
  data() {
    return {
        user:this.$store.state.user,
      showDelConfirm: false,
      horizontal: true,
      showList:true,
      showForm:false,
      frmdata:{group_name: '' },
      tblData: {
        tablename:'customergroup',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false
      },
    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "group_code",
            label: "Group Code",
            sortable: true
          },
          {
            key: "group_name",
            label: "Group Name",
            sortable: true
          }
        ];
        if (this.user.iklan==1) {
           fields.push({
            key: "iklan",
            label: "Advertising",
            sortable: true
          })
        }
        if (this.user.koran==1) {
           fields.push({
            key: "koran",
            label: "Newspaper",
            sortable: true
          })
        }
      fields.push( {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          }          
      );        
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await crud.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.frmdata.idlama = data.group_code;
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
      this.frmdata.iklan=this.frmdata.iklan||'0';
      this.frmdata.koran=this.frmdata.koran||'0';
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              this.frmdata.iklan= ((this.frmdata.agency==1) || (this.frmdata.advertiser==1)) ? 1 : 0;
              this.frmdata.koran= (this.frmdata.koranagen==1) ? 1 : 0;
              if (this.frmdata.idlama) {
                await crud.update(
                     {tablename:'customergroup', 
                     key:this.frmdata.idlama, 
                     data:{group_code:this.frmdata.group_code, group_name:this.frmdata.group_name,iklan:this.frmdata.iklan,koran:this.frmdata.koran,
                          agency:this.frmdata.agency, advertiser:this.frmdata.advertiser, koranagen: this.frmdata.koranagen}
                      });
              } else {
                await crud.insert(
                  { tablename:'customergroup',                      
                     data:{group_code:this.frmdata.group_code, group_name:this.frmdata.group_name,iklan:this.frmdata.iklan,koran:this.frmdata.koran,
                          agency:this.frmdata.agency, advertiser:this.frmdata.advertiser, koranagen: this.frmdata.koranagen}
                  });
              }
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({tablename:'customergroup', key:this.model.group_code});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
